
































































import { Component, Inject } from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';
import { UseService } from '@/services/service';
import { DataTableHeader } from 'vuetify';
import ClockIcon from '@/components/Helper/Icon/Svg/ClockIcon.vue';
import MonthSelectInput from '@/components/ViewComponent/Attendance/MonthSelectInput.vue';
import { WorkingReportEntity } from '@/entities/working-report.entity';
import WorkingReportService from '@/services/working-report.service';

@Component<Index>({
  components: { MonthSelectInput, ClockIcon },
  watch: {
    async month() {
      this.loading = true;
      await this.$nextTick();
      this.workingTimeData = await this.service.getWorkingTimeByMonth(
        this.month,
      );
      this.loading = false;
    },
  },
})
export default class Index extends Vue {
  loading = true;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => void;

  month: string = moment().format('MM/YYYY');

  @UseService(WorkingReportService)
  service: WorkingReportService;

  workingTimeData: WorkingReportEntity[] = [];

  get headers(): (DataTableHeader & {
    value: string | keyof WorkingReportEntity;
  })[] {
    return [
      {
        text: this.$t('time.day') as string,
        value: 'day',
        align: 'center',
      },
      {
        text: this.$t('attendance.checkinTime') as string,
        value: 'checkinTime',
        align: 'center',
      },
      {
        text: this.$t('attendance.checkoutTime') as string,
        value: 'checkoutTime',
        align: 'center',
      },
      // {
      //   text: this.$t('attendance.breakTime') as string,
      //   value: 'breakingTimes',
      //   align: 'center',
      // },
      {
        text: this.$t('attendance.workingHours') as string,
        value: 'workingTime',
        align: 'center',
      },
      {
        text: this.$t('attendance.overtimeHours') as string,
        value: 'overtime',
        align: 'center',
      },
      {
        text: this.$t('attendance.dailyReport') as string,
        value: 'dailyReport',
        align: 'center',
        width: '30%',
      },
    ];
  }

  async mounted(): Promise<void> {
    this.$cheeers.socket.on('daily_report@updated', async () => {
      this.workingTimeData = await this.service.getWorkingTimeByMonth(
        this.month,
      );
    });
    this.$cheeers.socket.on('daily_report@created', async () => {
      this.workingTimeData = await this.service.getWorkingTimeByMonth(
        this.month,
      );
    });
    this.workingTimeData = await this.service.getWorkingTimeByMonth(this.month);
    this.loading = false;
  }

  formatDay(value: moment.MomentInput): string {
    return moment(value).format(this.$t('calendar.formatMonthDay') as string);
  }

  formatTime(value: string): string {
    if (!value) {
      return value;
    }
    return value
      .split(':')
      .slice(0, 2)
      .join(':');
  }
}
